<template>
  <div v-if="groupLoaded">
    <div :class="pageClass">
      <mdb-mask :class="maskClass" :overlay="overlay">
        <div v-if="view=='main'">
          <banner suppressHomeIcon :group="groupInfo" showBannerEdit suppressQuestions/>
          <mdb-container>
            <mdb-card class="mb-2">
              <mdb-card-header class="secondary-color text-center">
              <mdb-btn icon="plus-circle" rounded size="sm" @click="addWizard">Add a Section</mdb-btn>
              <mdb-btn icon="arrows" rounded size="sm" @click="startRearranger">Re-Arrange Sections</mdb-btn>
              <mdb-btn @click="chooseBackgroundImage" icon="image" rounded size="sm">Background Image</mdb-btn>
              <a :href="groupInfo.absoluteUrl" target="_blank">
                <mdb-btn icon="external-link" rounded size="sm">View as Member</mdb-btn>
              </a>
              <mdb-btn v-if="!groupInfo.isPrivate" @click="viewPublic" icon="external-link" rounded size="sm">View as Public</mdb-btn>
              </mdb-card-header>
            </mdb-card>
            <div v-for="section in groupInfo.sections" v-if="section.location=='Top'" v-bind:key="section.id"
                 class="mb-4 text-left">
              <div class="primary-color-dark text-white p-2 text-right" style="width:100%">
                <mdb-row>
                  <mdb-col col="3">
                    <mdb-switch v-if="!groupInfo.isPrivate" :checked="section.isPublic" offLabel="" onLabel="Show To Public"
                                @getValue="handlePublic(section)"/>
                  </mdb-col>
                  <mdb-col col="3">
                    <mdb-switch :checked="section.isForMembers" offLabel="" onLabel="Show To Members"
                                @getValue="handleForMembers(section)"/>
                  </mdb-col>
                  <mdb-col col="6">
                    <mdb-btn v-if="sectionEditable(section)" color="warning" floating icon="pencil" size="sm" tag="a"
                             title="edit"
                             @click="editSection(section)"/>
                    <mdb-btn color="danger" floating icon="trash" size="sm" tag="a" @click="deleteSection(section)"/>
                  </mdb-col>
                </mdb-row>
              </div>
              <content-section v-if="section.type=='Content'" :group="groupInfo" :section="section"/>
              <activity-feed v-if="section.type=='Activity Feed'" :group="groupInfo" :maxRows="5"
                             :showLinks="groupInfo.role!='Public'"/>
              <slideshow-section v-if="section.type=='Slideshow'" :group="groupInfo" :section="section"/>
              <links-section v-if="section.type=='Page Links'" :group="groupInfo" :section="section"/>
              <file-folder-section v-if="section.type=='File Folder'" :group="groupInfo" :section="section"/>
              <image-section v-if="section.type=='Image'" :group="groupInfo" :section="section"/>
              <rss-feed-section v-if="section.type=='RSS Feed'" :group="groupInfo" :section="section"/>
              <facebook-feed-section v-if="section.type=='Facebook Feed'" :title="section.pageLinksTitle" :group="groupInfo" :section="section" :facebookPage="section.facebookPage"/>
              <Timeline v-if="section.type=='Twitter Feed'" :id="section.twitterName" sourceType="profile" :options="{ tweetLimit: section.tweetsToShow }"/>
              <image-feed-section v-if="section.type=='Image Feed'" :group="groupInfo" :section="section"/>
              <discussion-section v-if="section.type=='Recent Discussion'" :group="groupInfo" :section="section"/>
              <review-section v-if="section.type=='Review'" :group="groupInfo" :section="section"/>
              <team-section v-if="section.type=='Team'" :group="groupInfo" :section="section"/>
              <event-section v-if="section.type=='Upcoming Events'" :group="groupInfo" :section="section"/>
            </div>

            <mdb-row>
              <mdb-col class="text-left" md="7">
                <div v-for="section in groupInfo.sections" v-if="section.location=='Left' " v-bind:key="section.id">

                  <div class="primary-color-dark text-white p-2 text-right" style="width:100%">
                    <mdb-row>
                      <mdb-col col="3">
                        <mdb-switch v-if="!groupInfo.isPrivate" :checked="section.isPublic" offLabel="" onLabel="Show To Public"
                                    @getValue="handlePublic(section)"/>
                      </mdb-col>
                      <mdb-col col="3">
                        <mdb-switch :checked="section.isForMembers" offLabel="" onLabel="Show To Members"
                                    @getValue="handleForMembers(section)"/>
                      </mdb-col>
                      <mdb-col col="6">

                        <mdb-btn v-if="sectionEditable(section)" color="warning" floating icon="pencil" size="sm"
                                 tag="a"
                                 title="edit"
                                 @click="editSection(section)"/>
                        <mdb-btn color="danger" floating icon="trash" size="sm" tag="a"
                                 @click="deleteSection(section)"/>
                      </mdb-col>
                    </mdb-row>
                  </div>
                  <content-section v-if="section.type=='Content'" :group="groupInfo" :section="section"/>
                  <activity-feed v-if="section.type=='Activity Feed'" :group="groupInfo" :maxRows="5"
                                 :showLinks="groupInfo.role!='Public'"/>
                  <slideshow-section v-if="section.type=='Slideshow'" :group="groupInfo" :section="section"/>
                  <links-section v-if="section.type=='Page Links'" :group="groupInfo" :section="section"/>
                  <file-folder-section v-if="section.type=='File Folder'" :group="groupInfo" :section="section"/>
                  <image-section v-if="section.type=='Image'" :group="groupInfo" :section="section"/>
                  <rss-feed-section v-if="section.type=='RSS Feed'" :group="groupInfo" :section="section"/>
                  <facebook-feed-section v-if="section.type=='Facebook Feed'" :title="section.pageLinksTitle" :group="groupInfo" :section="section" :facebookPage="section.facebookPage"/>
                  <Timeline v-if="section.type=='Twitter Feed'" :id="section.twitterName" sourceType="profile" :options="{ tweetLimit: section.tweetsToShow }"/>
                  <image-feed-section v-if="section.type=='Image Feed'" :group="groupInfo" :section="section"/>
                  <discussion-section v-if="section.type=='Recent Discussion'" :group="groupInfo"
                                      :section="section"/>
                  <review-section v-if="section.type=='Review'" :group="groupInfo" :section="section"/>
                  <team-section v-if="section.type=='Team'" :group="groupInfo" :section="section"/>
                  <event-section v-if="section.type=='Upcoming Events'" :group="groupInfo" :section="section"/>
                </div>
              </mdb-col>

              <mdb-col class="text-left" md="5">
                <div v-for="section in groupInfo.sections" v-if="section.location=='Right'" v-bind:key="section.id">
                  <div class="primary-color-dark text-white p-2 text-right" style="width:100%">
                    <mdb-row>
                      <mdb-col col="3">
                        <mdb-switch v-if="!groupInfo.isPrivate" :checked="section.isPublic" offLabel="" onLabel="Show To Public"
                                    @getValue="handlePublic(section)"/>
                      </mdb-col>
                      <mdb-col col="3">
                        <mdb-switch :checked="section.isForMembers" offLabel="" onLabel="Show To Members"
                                    @getValue="handleForMembers(section)"/>
                      </mdb-col>
                      <mdb-col col="6">
                        <mdb-btn v-if="sectionEditable(section)" color="warning" floating icon="pencil" size="sm"
                                 tag="a"
                                 title="edit"
                                 @click="editSection(section)"/>
                        <mdb-btn color="danger" floating icon="trash" size="sm" tag="a"
                                 @click="deleteSection(section)"/>
                      </mdb-col>
                    </mdb-row>
                  </div>
                  <content-section v-if="section.type=='Content'" :group="groupInfo" :section="section"/>
                  <activity-feed v-if="section.type=='Activity Feed'" :group="groupInfo" :maxRows="5"
                                 :showLinks="groupInfo.role!='Public'"/>
                  <slideshow-section v-if="section.type=='Slideshow'" :group="groupInfo" :section="section"/>
                  <links-section v-if="section.type=='Page Links'" :group="groupInfo" :section="section"/>
                  <file-folder-section v-if="section.type=='File Folder'" :group="groupInfo" :section="section"/>
                  <image-section v-if="section.type=='Image'" :group="groupInfo" :section="section"/>
                  <rss-feed-section v-if="section.type=='RSS Feed'" :group="groupInfo" :section="section"/>
                  <facebook-feed-section v-if="section.type=='Facebook Feed'" :title="section.pageLinksTitle" :group="groupInfo" :section="section" :facebookPage="section.facebookPage"/>
                  <Timeline v-if="section.type=='Twitter Feed'" :id="section.twitterName" sourceType="profile" :options="{ tweetLimit: section.tweetsToShow }"/>
                  <image-feed-section v-if="section.type=='Image Feed'" :group="groupInfo" :section="section"/>
                  <discussion-section v-if="section.type=='Recent Discussion'" :group="groupInfo"
                                      :section="section"/>
                  <review-section v-if="section.type=='Review'" :group="groupInfo" :section="section"/>
                  <team-section v-if="section.type=='Team'" :group="groupInfo" :section="section"/>
                  <event-section v-if="section.type=='Upcoming Events'" :group="groupInfo" :section="section"/>
                </div>
              </mdb-col>
            </mdb-row>
          </mdb-container>
        </div>

        <section-designer v-if="view=='editor'"
                          :availablePages="availablePages"
                          :availableFolders="availableFolders"
                          :item="workingSection"
                          :pageTypes="pageTypes"
                          @cancelEdit="cancelEdit" @saved="sectionSaved"
        />

        <mdb-container v-if="view=='addWizard'" class="gp-has-header">
          <mdb-card>
            <mdb-card-header class="primary-color text-white">
              <h3>New Home Page Section</h3>
            </mdb-card-header>
            <mdb-card-body>
              <gp-select :dataObj="newSection" :possible-values="locations"
                         :required="true"
                         label="Display Location" propertyName="location"/>
              <gp-select :dataObj="newSection" :possible-values="pageTypes"
                         :required="true"
                         label="Section Type" propertyName="type"/>
              <gp-select v-if="newSection.type === 'Content'"
                         :dataObj="newSection" :possible-values="allContent"
                         :required="true"
                         label="Document" propertyName="existingContent"/>
            </mdb-card-body>
            <mdb-card-footer>
              <mdb-btn :disabled="!wizardReady" color="success" icon="check" @click="wizardDone">Continue</mdb-btn>
              <mdb-btn color="warning" icon="minus-circle" @click="view='main'">Cancel</mdb-btn>
            </mdb-card-footer>
          </mdb-card>
        </mdb-container>

        <mdb-container v-if="view=='rearranger'" class="gp-has-header">
          <mdb-card>
            <mdb-card-header class="primary-color text-white">
              <h3>Re-Arrange Sections</h3>
            </mdb-card-header>
            <mdb-card-body>
              <div class="text-info mb-2">
                Drag a section from one location to another to re-arrange the layout of your page.
              </div>
              <mdb-row>
                <mdb-col col="12">
                  <h4>Top Section</h4>
                  <mdb-list-group class="mb-4">
                    <draggable :list="topList" class="list-group" group="people" @change="reorder">
                      <mdb-list-group-item v-for="section in topList" :key="section.id">
                        {{ sectionLabel(section) }}
                      </mdb-list-group-item>
                    </draggable>
                  </mdb-list-group>

                </mdb-col>
              </mdb-row>
              <mdb-row>
                <mdb-col col="8">
                  <h4>Left Section</h4>
                  <mdb-list-group>
                    <draggable :list="leftList" class="list-group" group="people" @change="reorder">
                      <mdb-list-group-item v-for="section in leftList" :key="section.id">
                        {{ sectionLabel(section) }}
                      </mdb-list-group-item>
                    </draggable>
                  </mdb-list-group>
                </mdb-col>
                <mdb-col col="4">
                  <h4>Right Section</h4>
                  <mdb-list-group>
                    <draggable :list="rightList" class="list-group" group="people" @change="reorder">
                      <mdb-list-group-item v-for="section in rightList" :key="section.id">
                        {{ sectionLabel(section) }}
                      </mdb-list-group-item>
                    </draggable>
                  </mdb-list-group>

                </mdb-col>
              </mdb-row>
              <mdb-btn icon="check" @click="doneRearranging">Done</mdb-btn>
              <div class="text-info small">
                A bug in Chrome-based browsers can make the drag and drop not work. Make sure you are
                on the latest version of your browser.
              </div>
            </mdb-card-body>
          </mdb-card>
        </mdb-container>

        <div v-if="view=='background'" class="gp-has-header">
          <background-chooser @close="closeBackground" @newBackground="setBackground" type="group"/>
        </div>

      </mdb-mask>
    </div>
    <yes-no-modal v-if="deleteModal"
                  question="Are you sure you want to remove this section from your group's home page?"
                  @no="deleteModal=false"
                  @yes="doDeleteSection"/>

  </div>
</template>

<script>

import api from '../../services/groupsPlaceApi.js'
import {Timeline} from 'vue-tweet-embed';
import {
  mdbAlert,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardGroup,
  mdbCardHeader,
  mdbCardImage,
  mdbCardText,
  mdbCardTitle,
  mdbCol,
  mdbContainer,
  mdbDropdown,
  mdbDropdownItem,
  mdbDropdownMenu,
  mdbDropdownToggle,
  mdbFileInput,
  mdbIcon,
  mdbListGroup,
  mdbListGroupItem,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbNavbar,
  mdbPopover,
  mdbRow,
  mdbSwitch,
  mdbView
} from 'mdbvue';
import ContentSection from '../homeSections/Content'
import SlideshowSection from '../homeSections/SlideShow'
import LinksSection from '../homeSections/Links'
import ActivityFeed from "../ActivityFeed";
import Banner from './Banner'
import Checklist from './Checklist'
import ImageSection from '../homeSections/Image'
import FacebookFeedSection from "../homeSections/FacebookFeed";
import ImageFeedSection from '../homeSections/ImageFeed'
import DiscussionSection from '../homeSections/RecentDiscussion'
import ReviewSection from '../homeSections/Review'
import TeamSection from '../homeSections/Team'
import EventSection from '../homeSections/UpcomingEvents'
import FileFolderSection from "../homeSections/FileFolder";
import Error from '../common/Error'
import Vue from "vue";
import YesNoModal from "../common/YesNoModal";
import draggable from "vuedraggable";
import SectionDesigner from "../homeSections/SectionDesigner";
import gpSelect from "../common/GPSelect";
import BackgroundChooser from "./BackgroundChooser";
import RssFeedSection from "../homeSections/RssFeed";

export default {
  name: 'Home-Designer',
  components: {
    RssFeedSection,
    FacebookFeedSection,
    ContentSection,
    ActivityFeed,
    LinksSection,
    SlideshowSection,
    ImageSection,
    ImageFeedSection,
    DiscussionSection,
    FileFolderSection,
    ReviewSection,
    TeamSection,
    EventSection,
    Banner,
    Timeline,
    Checklist,
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbCardBody,
    mdbCardFooter,
    mdbCardTitle,
    mdbCardText,
    mdbDropdown,
    mdbListGroup,
    mdbListGroupItem,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbNavbar,
    mdbDropdownToggle,
    mdbDropdownMenu,
    mdbDropdownItem,
    mdbBtn,
    mdbView,
    mdbMask,
    mdbCardGroup,
    mdbIcon,
    mdbSwitch,
    mdbAlert,
    mdbPopover,
    mdbFileInput,
    Error,
    YesNoModal,
    draggable,
    SectionDesigner,
    gpSelect,
    BackgroundChooser
  },
  computed: {
    currentGroup() {
      return this.$store.state.currentGroup
    },
    settings() {
      return this.$store.state.settings
    },
    wizardReady() {
      if (!this.newSection) return false
      if (!this.newSection.type) return false
      if (!this.newSection.location) return false
      if (this.newSection.type == "Content" && !this.newSection.existingContent) return false
      return true
    }
  },
  data() {
    return {
      groupLoaded: false,
      groupInfo: null,
      errorMessage: null,
      error: null,
      pageClass: "",
      maskClass: "",
      overlay: "",
      editingSection: false,
      deleteCandidate: null,
      deleteModal: false,
      topList: [],
      leftList: [],
      rightList: [],
      view: "main",
      availablePages: null,
      availableFolders: null,
      workingSection: null,
      newSection: null,
      locations: [
        {text: 'Top', value: 'Top', selected: false},
        {text: 'Left', value: 'Left', selected: false},
        {text: 'Right', value: 'Right', selected: false}
      ],
      allContent: null,
      pageTypes: [
        {text: 'Activity Feed', value: 'Activity Feed', selected: false},
        {text: 'Event Image Feed', value: 'Image Feed', selected: false},
        {text: 'Facebook Feed', value: 'Facebook Feed', selected: false},
        {text: 'Group Review', value: 'Review', selected: false},
        {text: 'Image', value: 'Image', selected: false},
        {text: 'New Text', value: 'Content-New', selected: false},
        {text: 'Page Links', value: 'Page Links', selected: false},
        {text: 'Recent Discussion', value: 'Recent Discussion', selected: false},
        {text: 'RSS/Atom Feed', value: 'RSS Feed', selected: false},
        {text: 'Slideshow', value: 'Slideshow', selected: false},
        {text: 'Team Spotlight', value: 'Team', selected: false},
        {text: 'Twitter Feed', value: 'Twitter Feed', selected: false},
        {text: 'Upcoming Events', value: 'Upcoming Events', selected: false}
      ],
    };
  },
  mounted() {
    this.loadGroupInfo(false)

  },
  methods: {
    editSection(section) {
      if (!this.availablePages) this.loadAvailablePages()
      if (this.groupInfo.fileStorageEnabled && !this.availableFolders) {
        this.loadAvailableFolders()
      }
      this.$store.dispatch("setExecuting", true)
      api.get("/homepage/sectionDetails/" + section.id).then(
        (results) => {
          this.workingSection = results.data
          this.view = "editor"
        },
        (error) => {
          this.$notify.error({
                               message: "Section details could not be retrieved. " + error.response.data,
                               timeOut: 5000,
                               position: 'top center'
                             })
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    deleteSection(section) {
      this.deleteCandidate = section
      this.deleteModal = true
    },
    doDeleteSection() {
      this.$store.dispatch("setExecuting", true)
      this.deleteModal = false
      api.delete("/homepage/page/" + this.deleteCandidate.id).then(
        (results) => {
          let loc = this.groupInfo.sections.indexOf(this.deleteCandidate)
          if (loc >= 0) this.groupInfo.sections.splice(loc, 1)
        },
        (error) => {
          this.$notify.error({
                               message: "Section could not be deleted at this time.",
                               timeOut: 5000,
                               position: 'top center'
                             })
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    sectionLabel(section) {
      if (section.type == "Content") return section.content.title
      if (section.type == "Page Links") return section.pageLinksTitle
      return section.type

    },
    sectionEditable(section) {
      if (section.type == 'Content' || section.type == 'Page Links' ||
        section.type == "File Folder" || section.type == 'Facebook Feed' ||
        section.type == 'Twitter Feed' ||
        section.type == "Image" || section.type == "Team") {
        return true
      }
      return false
    },
    reorder(evt) {
      this.$store.dispatch("setExecuting", true)
      if (evt.moved || evt.added) {
        api.post("/homepage/resequence/" + this.groupInfo.vanityPath, {
          top: this.topList,
          left: this.leftList,
          right: this.rightList
        }).then(
          (results) => {

          },
          (error) => {
            this.$notify.error({
                                 message: "Setting could not be saved. Please try again later.",
                                 timeOut: 5000,
                                 position: 'top center'
                               })
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      }

    },
    startRearranger() {
      this.leftList = []
      this.rightList = []
      this.topList = []
      this.view = "rearranger"
      for (let s of this.groupInfo.sections) {
        if (s.location == "Left") this.leftList.push(s)
        if (s.location == "Right") this.rightList.push(s)
        if (s.location == "Top") this.topList.push(s)
      }
    },
    addWizard() {
      if (!this.availablePages) this.loadAvailablePages()
      if (this.groupInfo.fileStorageEnabled && !this.availableFolders) {
        this.loadAvailableFolders()
      }

      this.newSection = {
        type: "Content-New",
        id: null,
        image: null,
        isForMembers: true,
        isPublic: false,
        links: [],
        location: "Top",
        pageLinks: null,
        content: null,
        seqNum: 5,
        teamDisplay: 0,
        existingContent: null
      }
      this.view = "addWizard"
    },
    doneRearranging() {
      this.view = ""
      this.loadGroupInfo(true)
    },
    cancelEdit() {
      this.view = "main"
    },
    sectionSaved() {
      this.view = ""
      this.loadGroupInfo(true)
    },
    loadGroupInfo(refresh) {
      this.$store.dispatch("setExecuting", true)
      this.availablePages = null
      api.get("/group/home/" + this.$route.params.id + "/?viewAs=All").then(
        (response) => {
          if (!this.currentGroup || this.currentGroup.id != response.data.id || refresh) {
            this.$store.dispatch("setCurrentGroup", response.data)
          }
          this.groupInfo = response.data
          if (!this.groupInfo.permissions.includes("Edit Home Page")) {
            this.$router.push("/403")
            return
          }
          document.title = this.groupInfo.name
          this.$store.dispatch("setExecuting", false)
          if (this.groupInfo.background) this.setBackground(this.groupInfo.background)
          this.groupLoaded = true
          this.view = "main"
        },
        (error) => {
          this.$store.dispatch("setExecuting", false)
          this.$notify.error({message: error.response.data})
        }
      )
    },
    handleForMembers: function (section) {
      section.isForMembers = !section.isForMembers
      this.$store.dispatch("setExecuting", true)
      api.post("/homepage/setPerm/" + section.id, {field: "isForMembers", value: section.isForMembers}).then(
        (results) => {
          //life is good!
        },
        (error) => {
          this.$notify.error({
                               message: "Setting could not be saved. Please try again later.",
                               timeOut: 5000,
                               position: 'top center'
                             })
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    handlePublic: function (section) {
      section.isPublic = !section.isPublic
      this.$store.dispatch("setExecuting", true)
      api.post("/homepage/setPerm/" + section.id, {field: "isPublic", value: section.isPublic}).then(
        (results) => {
          //life is good
        },
        (error) => {
          this.$notify.error({
                               message: "Setting could not be saved. Please try again later.",
                               timeOut: 5000,
                               position: 'top center'
                             })
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    chooseBackgroundImage: function () {
      this.view = "background"
    },
    closeBackground: function () {
      this.view = "main"
    },
    setBackground: function (img) {
      if (this.view == "background") {
        this.view = "main"
        this.groupInfo.background = img
      }
      if (img) {
        this.pageClass = "full-view"
        this.maskClass = "overflow-auto"
        this.overlay = "stylish-strong"
      } else {
        this.maskClass = ""
        this.overlay = ""
      }
      Vue.nextTick().then(() => {
        let el = document.getElementsByClassName("full-view")
        if (el) {
          if (img) {
            el[0].setAttribute("style", "background-image: url('" + img + "');")
          } else {
            el[0].removeAttribute("style")
            this.pageClass = ""
          }
        }
      })
    },
    wizardDone() {
      if (this.newSection.type == "Content-New" ||
        this.newSection.type == "Image" ||
        this.newSection.type == "RSS Feed" ||
        this.newSection.type == "Facebook Feed" ||
        this.newSection.type == "Twitter Feed" ||
        this.newSection.type == "File Folder" ||
        this.newSection.type == "Page Links") {
        if (this.newSection.type == "Content-New") {
          this.newSection.type = "Content"
          this.newSection.content = {id: null, html: "", title: "", isPublic: true}
        }

        this.workingSection = this.newSection
        this.view = "editor"
        return
      }
      if (this.newSection.type == "Content") {
        this.newSection.content = {
          id: this.newSection.existingContent
        }
      }
      this.$store.dispatch("setExecuting", true)
      api.post("/homepage/save/" + this.groupInfo.vanityPath, this.newSection).then(
        (results) => {
          this.loadGroupInfo()
        },
        (error) => {
          this.$notify.error({messageText: "Error saving section."})

        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })


    },
    loadAvailableFolders() {
      api.get("/homepage/availableFolders/" + this.groupInfo.vanityPath).then(
        (results) => {
          this.availableFolders = results.data
          if (this.availableFolders.length > 0) {
            this.pageTypes.unshift( {text: 'File Folder Contents', value: 'File Folder', selected: false})
          }
        },
        (error) => {
          this.$notify.error({
                               message: "Could not load available content.",
                               timeOut: 5000,
                               position: 'top center'
                             })
        })
    },
    loadAvailablePages() {
      api.get("/homepage/availablePages/" + this.groupInfo.vanityPath).then(
        (results) => {
          this.availablePages = results.data
          if (this.availablePages.length > 0) {
            let hasDoc = false
            for (let x of this.pageTypes) {
              if (x.value == "Content") hasDoc = true
            }
            if (!hasDoc) this.pageTypes.unshift({text: 'Text from Existing Document', value: 'Content', selected: false})
            this.allContent = []
            for (let t of this.availablePages) {
              if (t.type == "CONTENT") {
                this.allContent.push({text: t.title, value: t.id})
              }
            }
          }
        },
        (error) => {
          this.$notify.error({
                               message: "Could not load available content.",
                               timeOut: 5000,
                               position: 'top center'
                             })
        })
    },
    viewPublic() {
      let url = this.groupInfo.absoluteUrl
      if (url.indexOf("?") > 0) {
        url += "&viewAs=Public"
      } else url += "?viewAs=Public"
      window.open(url)
    }

  }
}
;
</script>
